export default "../css/0c8dd49a92562d446d3bcd3d8a148b87.ttf";